const contributionDataReducer = (state = {}, action) => {
    switch (action.type) {
        case 'UPDATE_CONTRIBUTION_DATA':
            return action.data;
        default:
            return state;
    }
};

export default contributionDataReducer;